module.exports = __webpack_public_path__ + "img/header.9ba797c5.jpg";